import React from "react";
import { Outlet } from "react-router-dom";
// import Navbar from "../../pages/header/Navbar";
import Sidebar from "../Sidebar";

const Layout = () => {


    return (
        <div className="flex h-screen">

            <Sidebar />
<div className="flex flex-col flex-1">
            <main className="flex-1 bg-gray-100 overflow-y-auto px-2 py-1">
                {/* <Navbar /> */}
                <section>
                    <Outlet />
                </section>
                
            </main>
      
<footer className="bg-sidecolor text-white py-2 sm:py-2 md:py-2 flex flex-row items-center ml-[-1px]">
      <div className={`container mx-auto px-3 sm:px-4 md:px-8`}>
        <div className="flex items-center justify-center md:justify-between flex-wrap gap-1 sm:gap-2 md:gap-4">
          <div className="flex items-center gap-2">
            <span className="text-slate-200 text-xs md:text-sm">
              © {new Date().getFullYear()} OPTIM OPS. All rights reserved.
            </span>
          </div>
           <div className="flex flex-row items-center text-slate-200 justify-center md:justify-end gap-1 text-xs md:text-sm">
            <span>Designed for operational excellence by</span>
            <img src="/footerlogo.png" alt="Metagrad Logo" className="w-4 h-4 md:w-6 md:h-5" />
            <a
              href="https://metagrad.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-xs md:text-sm text-slate-200 hover:text-gray-300 transition no-underline"
            >
              Metagrad Labs
            </a>
          </div>
        </div>
      </div>
    </footer>

            </div>
        </div>
    );
};

export default Layout;